// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from "@/util/util.js"; //引入公共的方法
Vue.prototype.utils = utils; //原型指向该方法
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import store from "./vuex/store"; // 引入store,和vuex有关

Vue.config.productionTip = false
Vue.use(ViewUI);

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

//公共组件
import plugins from "./util/plugins";
Vue.use(plugins)

import lycsr from "../config/lycsr";
Vue.prototype.lycsr = lycsr;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
//请求拦截器
import '../config/axios'





// WEBPACK FOOTER //
// ./src/main.js